export default function SelectProduct(state, payload){
  const {product} = payload;
  state.selectedProducts[product.id] = product;
  return {...state}
}